module.exports = __webpack_public_path__ + "img/geocollections.90a878e1.jpg";